import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  FormControl,
  IconButton,
  Input,
  InputAdornment
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: '10px',
    width: 250,
  },
}));

const CustomSearchBar = props => {
  const { searchText, updateSearchText, ...rest } = props;

  const classes = useStyles();
  const [customSearchText, setCustomSearchText] = useState(searchText);
  const onSearchValueChange = (e) => { return updateSearchText(customSearchText); };
  const onSearchValueClear = () => { return updateSearchText(''); };

  const handleValueChange = (e) => {
    setCustomSearchText(e.target.value)
  }

  const handleKeyUp = (event) => {
    //key code for enter
    if (event.keyCode === 13) {
      event.preventDefault();
      event.target.blur();
    }
  }

  return (
    <FormControl className={classes.formControl}>
      <Input
        fullWidth={true}
        type="text"
        value={customSearchText}
        onBlur={(e) => { onSearchValueChange(e) }}
        onChange={(e) => { handleValueChange(e) }}
        onKeyUp={handleKeyUp}
        startAdornment={<InputAdornment position="end"><SearchIcon /></InputAdornment>}
        endAdornment={
          (searchText !== '') ?
            <InputAdornment position="end">
              <IconButton
                onClick={(e) => { onSearchValueClear(e) }}
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
            : ''
        }
      />
    </FormControl>
  );
};

CustomSearchBar.propTypes = {
  searchText: PropTypes.string,
  updateSearchText: PropTypes.any,
};

export default CustomSearchBar;
